<template>

  <span :style="{ color: 'var(--tokens-textDisabled)' }">—</span>

</template>


<script>

  export default {
    name: 'KEmptyPlaceholder',
  };

</script>


<style lang="scss" scoped></style>
